import { z } from "zod";

export enum CommunityType {
  basic = "basic",
  class = "class",
  parish = "parish",
  network = "network",
  small_group = "small_group",
  school = "school",
}

export const communityTypeEnum = z.enum(CommunityType);
